module.exports = __webpack_public_path__ + "static/media/CI.352f7ca0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CI.svg
// module id = 224
// module chunks = 0